<template>
    <!--是否确定操作弹框 start-->
    <v-dialog v-model="isShowDialog" persistent max-width="500">
        <v-card>
            <v-card-title>提示</v-card-title>
            <v-card-text>{{msg}}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="cancel">取消</v-btn>
                <v-btn color="primary" @click="confirm">确定</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--是否确定操作弹框 end-->
</template>

<script>
  export default {
    name: "ZConfirm",
    data: () => ({}),
    props: {
      value:{
        type:Boolean,
        default:false
      },
      msg: {
        type: String,
        default: ''
      }
    },
    computed: {
      isShowDialog: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    },
    methods: {
      confirm() {
        this.$emit('confirm');
      },
      cancel(){
        this.isShowDialog = false
      },
    }
  }
</script>

<style scoped>

</style>